import React, { useEffect, useState } from 'react';
import { InstaPayVService } from '../../../services/V2/gozer';
import { TokensVService } from '../../../services/V3/gozer';
import { handleError } from '../../Shared/Functions';
import { CircularProgress } from '@mui/material';
import { I3PayFacFrame } from '../../Shared/I3PayFacFrame';

export function CCIframe({ children, onComplete, fail, useAnon, accountId, saveToWallet, tokenCreateError, setPaymentMethod }) {
    const [count, setCount] = useState<number>(0);
    const [url, setUrl] = useState<any>();
    const [refresh, setRefresh] = useState<boolean>(true);
    const [loading, ...middle] = React.Children.toArray(children)
    const saved = middle.pop()
    const [tokenId, setTokenId] = useState<string | null>("");
    const [pluginLoading, setPluginLoading] = useState<boolean>(false);

    useEffect(() => {
        if (!refresh) return;
        if (useAnon) {
            InstaPayVService.instaPayVGetCcUrl(accountId ?? "")
                .then(urlInfo => {
                    setUrl(urlInfo);
                    setRefresh(false);
                }).catch(err => {
                    setRefresh(false)
                });
        } else {
            TokensVService
                .tokensVGetCcUrl(accountId ?? "", {
                    billingAccountId: accountId ?? ""
                })
                .then(urlInfo => {
                    setUrl(urlInfo);
                    setRefresh(false);
                }).catch(err => {
                    fail(handleError(err))
                    setRefresh(false)
                });
        }
    }, [accountId, refresh])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        // The modal has been Submitted
        if (count === 2) {
            if (!useAnon && tokenId) {
                TokensVService.tokensVCreateCc(accountId ?? "", saveToWallet, {
                    tokenId
                })
                    .then(tokenExchange => {
                        onComplete && onComplete(tokenExchange)
                    })
                    .catch(err => {
                        fail(handleError(err))
                        tokenCreateError()
                    })
            }
            else if (useAnon) {
                onComplete(null, url.id);
            }
        }
    }, [count])// eslint-disable-line react-hooks/exhaustive-deps
    return <>
        {count === 0 && loading}
        {count === 1 && middle}
        {count === 2 && saved}
        {((count === 2 && !useAnon) || pluginLoading) && <div className='loading-container'><CircularProgress className='center-spinner' color="primary" aria-label="Loading" /></div>}
        {!url ? <div /> :
            <>
                <I3PayFacFrame url={url} setCount={setCount} setTokenId={setTokenId} setPaymentMethod={setPaymentMethod} setPluginLoading={setPluginLoading} />
            </>
        }
    </>
}
